import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

export const xhSet = (name, value) => {
    cookies.set(
        name,
        {
            ...cookies.get(name),
            ...value,
        },
        "30d",
        "/",
        // ".rastargames.com"
    );
}

export const xhGet = (name) => {
    return cookies.get(name)
}